import { bootstrapConfig, headerConfig } from './config';
import { isOpenBetSessionProxyModeEnabled } from './utils/isOpenBetSessionProxyModeEnabled';
import { isDeviceNative } from './utils/deviceDetection';

// eslint-disable-next-line complexity
const getBootstrapConfig = (bootstrapFeatures) => {
  const isCASSessionManagerEnabled = bootstrapFeatures.find(
    (feature) => feature.name === '@feature/cas-session-manager'
  );
  const isOAuthSessionManagerEnabled = bootstrapFeatures.find(
    (feature) => feature.name === '@feature/oauth-session-manager'
  );
  const isNativeApp = isDeviceNative();

  if (isCASSessionManagerEnabled && bootstrapConfig['@feature/cas-session-manager']) {
    bootstrapConfig['@feature/cas-session-manager'].isNativeAppDevice = isNativeApp;
  }

  if (isOAuthSessionManagerEnabled && bootstrapConfig['@feature/oauth-session-manager']) {
    bootstrapConfig['@feature/oauth-session-manager'].enableSessionValidateMode = isNativeApp;

    if (bootstrapConfig['@feature/session-service']) {
      bootstrapConfig['@feature/session-service'].enableSessionManagerProxyMode = true;
    }

    if (bootstrapConfig['@feature/obsession-service']) {
      bootstrapConfig['@feature/obsession-service'].enableSessionManagerProxyMode = isOpenBetSessionProxyModeEnabled();
    }

    if (bootstrapConfig['@feature/apollo-data-access-service']) {
      bootstrapConfig['@feature/apollo-data-access-service'].url = headerConfig.graphQLClient.oauthUrl;
      bootstrapConfig['@feature/apollo-data-access-service'].authorizationMode = 'SessionContainerOAuthToken';
    }
  }

  if (
    bootstrapConfig['@feature/myaccount'] &&
    headerConfig.myAccount &&
    headerConfig.myAccount.neverOpenOnNative &&
    isNativeApp
  ) {
    bootstrapConfig['@feature/myaccount'].neverOpen = true;
  }

  return bootstrapConfig;
};

export default getBootstrapConfig;
